<template>
  <div>
    <div class="ts-grid ts-grid-cols-1 ts-gap-3">
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0 required">{{
            $t('serviceRequest.serviceRequestDate')
          }}</label>
          <a-date-picker
            v-model="model.service_request_date"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            class="ts-w-full"
          ></a-date-picker>
          <div class="validate" v-if="errors.has('service_request_date')">
            {{ errors.first('service_request_date') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0 required ts-font-robot">{{
            $t('serviceRequest.serviceStatus')
          }}</label>
          <a-select
            v-model="model.service_status"
            :options="serviceStatus"
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('service_status') }"
            placeholder="Select"
          ></a-select>
          <div class="validate" v-if="errors.has('service_status')">
            {{ errors.first('service_status') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0 required">{{
            $t('serviceRequest.serviceRequestType')
          }}</label>
          <a-select
            v-model="model.service_request_type_id"
            :options="serviceRequestTypes"
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{
              'is-invalid': errors.has('service_request_type_id')
            }"
            placeholder="Select"
            @change="onChangeServiceRequestType"
          ></a-select>
          <div class="validate" v-if="errors.has('service_request_type_id')">
            {{ errors.first('service_request_type_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0">{{ $t('serviceRequest.feeType') }}</label>
          <a-select
            v-model="model.fee_type_id"
            :options="feeTypes"
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('fee_type_id') }"
            placeholder="Select"
          ></a-select>
          <div class="validate" v-if="errors.has('fee_type_id')">
            {{ errors.first('fee_type_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0">{{ $t('serviceRequest.orderKads') }}</label>
          <input v-model="model.order_kads" type="text" class="form-control" />
          <div class="validate" v-if="errors.has('order_kads')">
            {{ errors.first('order_kads') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="ts-mb-0 required">{{
            $t('serviceRequest.owner')
          }}</label>
          <a-select
            v-model="model.owner"
            :options="owners"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('owner') }"
            placeholder="Select"
          ></a-select>
          <div class="validate" v-if="errors.has('owner')">
            {{ errors.first('owner') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="ts-mb-0">{{ $t('serviceRequest.informant') }}</label>
          <a-select
            v-model="model.informant"
            :options="owners"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('informant') }"
            placeholder="Select"
          ></a-select>
          <div class="validate" v-if="errors.has('informant')">
            {{ errors.first('informant') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
export default {
  props: ['value', 'validate'],
  components: {},
  data() {
    return {
      loading: false,
      errors: new Errors(),
      show_project: false,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('serviceManagement/serviceRequest', ['formViewDatas']),
    serviceRequestTypes() {
      if (this.formViewDatas['serviceRequestTypes']) {
        return this.formViewDatas['serviceRequestTypes'].map(el => ({
          value: el.service_request_type_id,
          label: el.service_request_type,
          service_request_schedule: el.service_request_schedule
        }))
      }
      return []
    },
    feeTypes() {
      if (this.formViewDatas['feeTypes']) {
        return this.formViewDatas['feeTypes'].map(el => ({
          value: el.product_id,
          label: el.product_name_en
        }))
      }
      return []
    },
    owners() {
      if (this.formViewDatas['owners']) {
        return this.formViewDatas['owners'].map(el => ({
          value: el.user_id,
          label: el.employee_name_kh + '|' + el.employee_name_en
        }))
      }
      return []
    },
    serviceStatus() {
      return [
        {
          label: 'Pending',
          value: 0
        },
        {
          label: 'Progressing',
          value: 1
        },
        {
          label: 'Completed',
          value: 2
        },
        {
          label: 'Cancel',
          value: 3
        }
      ]
    }
  },
  methods: {
    ...mapActions('serviceManagement/serviceRequest', ['getFormViewModel']),
    async onChangeServiceRequestType(value) {
      if (value == 1) {
        this.model.stock_out_id = null
        this.model.product_id = null
        this.model.serial_no = null
      }
      this.$emit('setLoading', true)
      await this.getFormViewModel({
        index: 'invoices,serials',
        params: {
          fnName: 'invoices,serials',
          customer_id: this.model.requested_by,
          service_request_type_id: value
        }
      })
      this.$emit('setLoading', false)
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style>
.ant-calendar-picker-input {
  height: 32px !important;
}
</style>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
.form-control {
  height: 32px;
}
</style>
